import Cookies from 'js-cookie'

const cookies = {}

/**
 * @description 存储 cookie 值
 * @param {String} name cookie name
 * @param {String} value cookie value
 * @param {Object} setting cookie setting
 */
cookies.set = function (name = 'default', value = '', expiresTime) {
   let seconds = expiresTime
   let expires = new Date(new Date() * 1 + seconds * 1000)
   Cookies.set(`tccc-${name}`, value, { expires: expires })
}

/**
 * @description 拿到 cookie 值
 * @param {String} name cookie name
 */
cookies.get = function (name = 'default') {
   return Cookies.get(`tccc-${name}`)
}

/**
 * @description 拿到 cookie 全部的值
 */
cookies.getAll = function () {
   return Cookies.get()
}

/**
 * @description 删除 cookie
 * @param {String} name cookie name
 */
cookies.remove = function (name = 'default') {
   return Cookies.remove(`tccc-${name}`)
}

/**
 * @description 删除 cookie
 * @param {String} name cookie name
 */
cookies.getCookieExpirationLeft = function (cookieName) {
   const cookie = cookies.get(cookieName)
   if (!cookie) {
      return null // 如果cookie不存在，返回null
   }

   const expires = JSON.parse(cookies.get(cookieName)).replace(
      /^(.*;)?(.*)$/,
      '$2'
   )
   console.log(
      expires,
      'expiresexpiresexpiresexpiresexpiresexpiresexpiresexpiresexpires'
   )

   const expirationDate = new Date(expires)
   const now = new Date()

   // 计算剩余时间，单位为毫秒，然后转换为秒
   const timeLeft = expirationDate - now
   const secondsLeft = Math.floor(timeLeft / 1000)

   return secondsLeft
}

export default cookies
